import React from "react";
import { Routing } from "./Routing";
import { AppState, persistor } from "../store";
import { CssBaseline } from "@material-ui/core";
import { Provider } from "react-redux";
import { Store } from "redux";
import { FullScreenFetching } from "../components/holders/FullScreenFetching";
import { Theme } from "./Theme";
import { PersistGate } from "redux-persist/integration/react";
import { Loading } from "../components/holders/Loading";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import LuxonUtils from "@date-io/luxon";

type P = {
  store: Store<AppState>;
};

function App(p: P) {
  return (
    <MuiPickersUtilsProvider utils={LuxonUtils}>
      <Provider store={p.store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <Theme>
            <CssBaseline />
            <Routing />
            <FullScreenFetching />
          </Theme>
        </PersistGate>
      </Provider>
    </MuiPickersUtilsProvider>
  );
}

export default App;
